import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Roles } from 'src/app/shared/services/names.service';
import { AuthService } from 'src/app/modules/auth/services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class MarketingRoleGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {

  }
  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot) {
    const currentRole = await this.authService.getUserRoles()
    if (currentRole === Roles.mktUser || currentRole === Roles.adminUser)
      return true
    else {
      this.router.navigate(['/forbidden'])
      return false
    }
  }

}
